// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Moment = require("moment");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var ReactMasonryCss = require("react-masonry-css").default;
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("./common/http.res.js");
var Chart$ReactHooksTemplate = require("./dashboard/dashboard/chart.res.js");
var HtmlToPdf$ReactHooksTemplate = require("./dashboard/dashboard/htmlToPdf.res.js");
var ComposedChartComponent$ReactHooksTemplate = require("./dashboard/dashboard/ComposedChartComponent.res.js");

function ratingReportRowDecoder(json) {
  return {
          type_: Json_decode.field("type", Json_decode.string, json),
          promoterCount: Json_decode.field("promoter_count", Json_decode.$$int, json),
          promoterPercentage: Json_decode.field("promoter_percentage", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          detractorCount: Json_decode.field("detractor_count", Json_decode.$$int, json),
          detractorPercentage: Json_decode.field("detractor_percentage", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          passiveCount: Json_decode.field("passive_count", Json_decode.$$int, json),
          passivePercentage: Json_decode.field("passive_percentage", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          total: Json_decode.field("total", Json_decode.$$int, json),
          npsScore: Json_decode.field("nps_score", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json)
        };
}

function ratingReportDecoder(json) {
  return {
          market: Json_decode.field("market", ratingReportRowDecoder, json),
          nonMarket: Json_decode.field("non_market", ratingReportRowDecoder, json),
          overall: Json_decode.field("overall", ratingReportRowDecoder, json)
        };
}

function weeklyReportRowDecoder(json) {
  return {
          week: Json_decode.optional((function (param) {
                  return Json_decode.field("date", Json_decode.string, param);
                }), json),
          monday: Json_decode.field("monday", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          tuesday: Json_decode.field("tuesday", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          wednesday: Json_decode.field("wednesday", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          thursday: Json_decode.field("thursday", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          friday: Json_decode.field("friday", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          saturday: Json_decode.field("saturday", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json),
          sunday: Json_decode.field("sunday", (function (param) {
                  return Json_decode.optional(Json_decode.$$float, param);
                }), json)
        };
}

function weeklyReportDecoder(json) {
  return {
          overall: Json_decode.field("overall", weeklyReportRowDecoder, json),
          weeks: Json_decode.field("week_wise", (function (param) {
                  return Json_decode.list(weeklyReportRowDecoder, param);
                }), json)
        };
}

function weeklyReportRow(rowData) {
  var match = rowData.week;
  var rowStyle = match !== undefined ? "" : "bg-gray-200";
  var week = rowData.week;
  return JsxRuntime.jsxs("tr", {
              children: [
                JsxRuntime.jsx("td", {
                      children: week !== undefined ? week : "8 week average",
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.monday, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.tuesday, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.wednesday, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.thursday, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.friday, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.saturday, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.sunday, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    })
              ],
              className: rowStyle
            });
}

function ratingReportHeader(param) {
  return JsxRuntime.jsx("thead", {
              children: JsxRuntime.jsxs("tr", {
                    children: [
                      JsxRuntime.jsx("th", {
                            children: "Type",
                            className: "p-2"
                          }),
                      JsxRuntime.jsx("th", {
                            children: "NPS Score",
                            className: "p-2"
                          }),
                      JsxRuntime.jsx("th", {
                            children: "Total Responses",
                            className: "p-2"
                          }),
                      JsxRuntime.jsx("th", {
                            children: "Demoter%",
                            className: "p-2"
                          }),
                      JsxRuntime.jsx("th", {
                            children: "Demoter",
                            className: "p-2"
                          }),
                      JsxRuntime.jsx("th", {
                            children: "Promoter%",
                            className: "p-2"
                          }),
                      JsxRuntime.jsx("th", {
                            children: "Promoter",
                            className: "p-2"
                          })
                    ]
                  }),
              className: "font-medium border-b bg-secondary\n                    text-gray-400"
            });
}

function ratingReportRow(rowData) {
  var rowStyle = rowData.type_ === "Overall" ? "bg-gray-200" : "";
  return JsxRuntime.jsxs("tr", {
              children: [
                JsxRuntime.jsx("td", {
                      children: rowData.type_,
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.npsScore, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: String(rowData.total),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.detractorPercentage, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: String(rowData.detractorCount),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(rowData.promoterPercentage, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: String(rowData.promoterCount),
                      className: "p-2 border border-gray-600"
                    })
              ],
              className: rowStyle
            });
}

function reportDecoder(json) {
  return {
          currentDayRating: Json_decode.field("report", (function (param) {
                  return Json_decode.field("current_day_split", ratingReportDecoder, param);
                }), json),
          currentMonthRating: Json_decode.field("report", (function (param) {
                  return Json_decode.field("current_month_split", ratingReportDecoder, param);
                }), json),
          yesterdayRating: Json_decode.field("report", (function (param) {
                  return Json_decode.field("yesterday_data", ratingReportDecoder, param);
                }), json),
          lastMonthRating: Json_decode.field("report", (function (param) {
                  return Json_decode.field("last_month_data", ratingReportDecoder, param);
                }), json),
          rolling5Day: Json_decode.field("report", (function (param) {
                  return Json_decode.field("rolling_5_day_trend", Chart$ReactHooksTemplate.fromJson, param);
                }), json),
          weeklyNpsTrend: Json_decode.field("report", (function (param) {
                  return Json_decode.field("weekly_nps_trend", weeklyReportDecoder, param);
                }), json),
          pdpTrend: Json_decode.field("report", (function (param) {
                  return Json_decode.field("pdp_trend", Chart$ReactHooksTemplate.fromJson, param);
                }), json)
        };
}

function downloadAsPdf(param) {
  var element = Belt_Option.getExn(Caml_option.nullable_to_opt(document.querySelector("#daily-report")));
  HtmlToPdf$ReactHooksTemplate.generatePdf(element);
}

function ratingComparisonReportRow(report, type_) {
  var rowStyle = type_ === "Overall" ? "bg-gray-200" : "";
  var match;
  switch (type_) {
    case "Marketplace" :
        match = [
          report.yesterdayRating.market,
          report.currentMonthRating.market,
          report.lastMonthRating.market
        ];
        break;
    case "Non Marketplace" :
        match = [
          report.yesterdayRating.nonMarket,
          report.currentMonthRating.nonMarket,
          report.lastMonthRating.nonMarket
        ];
        break;
    default:
      match = [
        report.yesterdayRating.overall,
        report.currentMonthRating.overall,
        report.lastMonthRating.overall
      ];
  }
  var lastMonth = match[2];
  var currentMonth = match[1];
  var yesterday = match[0];
  return JsxRuntime.jsxs("tr", {
              children: [
                JsxRuntime.jsx("td", {
                      children: type_,
                      className: "p-2 border-l border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(yesterday.npsScore, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border-l border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: String(yesterday.total),
                      className: "p-2"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(currentMonth.npsScore, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border-l border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: String(currentMonth.total),
                      className: "p-2"
                    }),
                JsxRuntime.jsx("td", {
                      children: Belt_Option.mapWithDefault(lastMonth.npsScore, "--", (function (x) {
                              return x.toString();
                            })),
                      className: "p-2 border-l border-gray-600"
                    }),
                JsxRuntime.jsx("td", {
                      children: String(lastMonth.total),
                      className: "p-2 border-r border-gray-600"
                    })
              ],
              className: " " + rowStyle + " border-b border-gray-600 "
            });
}

function DailyReport(props) {
  var params = Querystringify.parse(props.params);
  var reportDate = Belt_Option.getWithDefault(Js_dict.get(params, "date"), Moment().format("DD-MM-YYYY"));
  var match = React.useState(function (param) {
        return "Loading";
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function (param) {
          Js_promise.$$catch((function (err) {
                  return Promise.resolve((console.log(err), undefined));
                }), Js_promise.then_((function (json) {
                      return Promise.resolve((Curry._1(setState, (function (param) {
                                          return {
                                                  TAG: "Available",
                                                  _0: reportDecoder(json)
                                                };
                                        })), undefined));
                    }), Http$ReactHooksTemplate.fetchGetJSON("/api/v1/daily_report_data?date=" + reportDate)));
        }), []);
  var onClick = function (param, param$1, param$2) {
    
  };
  var tmp;
  if (typeof state !== "object") {
    tmp = JsxRuntime.jsx("p", {
          children: "Loading"
        });
  } else {
    var report = state._0;
    var chartAttribute = Chart$ReactHooksTemplate.type_(report.rolling5Day);
    var tmp$1;
    tmp$1 = typeof chartAttribute !== "object" || chartAttribute.TAG !== "ComposedChart" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx(ComposedChartComponent$ReactHooksTemplate.make, {
            chartId: Chart$ReactHooksTemplate.id(report.rolling5Day),
            chartAttribute: chartAttribute._0,
            drillDownKey: undefined,
            onClick: onClick,
            enlarged: true,
            chartHeight: "h-64",
            containerWidth: 1280
          });
    var chartAttribute$1 = Chart$ReactHooksTemplate.type_(report.pdpTrend);
    var tmp$2;
    tmp$2 = typeof chartAttribute$1 !== "object" || chartAttribute$1.TAG !== "ComposedChart" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx(ComposedChartComponent$ReactHooksTemplate.make, {
            chartId: Chart$ReactHooksTemplate.id(report.pdpTrend),
            chartAttribute: chartAttribute$1._0,
            drillDownKey: undefined,
            onClick: onClick,
            enlarged: true,
            chartHeight: "h-64",
            containerWidth: 1280
          });
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {}),
                    JsxRuntime.jsx("button", {
                          children: "Export",
                          className: "bg-white border-2 border-gray-300 p-2\n                       shadow-inner w-1/12",
                          onClick: (function (param) {
                              downloadAsPdf();
                            })
                        })
                  ],
                  className: "flex px-16 w-full items-center justify-between"
                }),
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("p", {
                                            children: "NPS Daily Report - " + reportDate,
                                            className: "text-2xl font-extrabold text-radicalred w-full\n                 text-center"
                                          }),
                                      className: "flex flex-col items-center justify-center mt-50-px\n               mb-20-px"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("p", {
                                                      children: "Yesterday's NPS score: ",
                                                      className: "mx-auto mb-20-px"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: Belt_Option.mapWithDefault(report.yesterdayRating.overall.npsScore, "--", (function (x) {
                                                              return x.toString();
                                                            })),
                                                      className: "mx-auto text-3xl"
                                                    })
                                              ],
                                              className: "border border-black border-2 w-2/3 py-10-px mr-10-px\n              flex flex-col justify-center"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("p", {
                                                      children: "Current Month's NPS score: ",
                                                      className: "mx-auto mb-20-px"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: Belt_Option.mapWithDefault(report.currentMonthRating.overall.npsScore, "--", (function (x) {
                                                              return x.toString();
                                                            })),
                                                      className: "mx-auto text-3xl"
                                                    })
                                              ],
                                              className: "border border-black border-2 w-2/3 p-10-px mr-10-px flex flex-col justify-center"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("p", {
                                                      children: "Last Month's NPS score: ",
                                                      className: "mx-auto mb-20-px"
                                                    }),
                                                JsxRuntime.jsx("p", {
                                                      children: Belt_Option.mapWithDefault(report.lastMonthRating.overall.npsScore, "--", (function (x) {
                                                              return x.toString();
                                                            })),
                                                      className: "mx-auto text-3xl"
                                                    })
                                              ],
                                              className: "border border-black border-2 w-2/3 p-10-px flex\n            flex-col justify-center"
                                            })
                                      ],
                                      className: "flex py-10-px justify-between items-center text-xl\n          font-bold mb-50-px"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs(ReactMasonryCss, {
                                            breakpointCols: 1,
                                            className: "flex w-auto",
                                            columnClassName: "",
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Daily NPS Rating Report:",
                                                            className: "text-xl font-bold mb-10-px"
                                                          }),
                                                      JsxRuntime.jsxs("table", {
                                                            children: [
                                                              ratingReportHeader(),
                                                              JsxRuntime.jsxs("tbody", {
                                                                    children: [
                                                                      ratingReportRow(report.currentDayRating.market),
                                                                      ratingReportRow(report.currentDayRating.nonMarket),
                                                                      ratingReportRow(report.currentDayRating.overall)
                                                                    ],
                                                                    className: "text-center"
                                                                  })
                                                            ],
                                                            className: "w-full border border-black border-2"
                                                          })
                                                    ],
                                                    className: "mb-50-px w-auto"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Monthly NPS Rating Report:",
                                                            className: "text-xl font-bold mb-10-px"
                                                          }),
                                                      JsxRuntime.jsxs("table", {
                                                            children: [
                                                              ratingReportHeader(),
                                                              JsxRuntime.jsxs("tbody", {
                                                                    children: [
                                                                      ratingReportRow(report.currentMonthRating.market),
                                                                      ratingReportRow(report.currentMonthRating.nonMarket),
                                                                      ratingReportRow(report.currentMonthRating.overall)
                                                                    ],
                                                                    className: "text-center"
                                                                  })
                                                            ],
                                                            className: "w-full border border-black border-2"
                                                          })
                                                    ],
                                                    className: "mb-50-px"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "NPS Rating Comparison:",
                                                            className: "text-xl font-bold mb-10-px"
                                                          }),
                                                      JsxRuntime.jsxs("table", {
                                                            children: [
                                                              JsxRuntime.jsxs("thead", {
                                                                    children: [
                                                                      JsxRuntime.jsxs("tr", {
                                                                            children: [
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: JsxRuntime.jsx("div", {}),
                                                                                    className: "bg-white"
                                                                                  }),
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "Yesterday",
                                                                                    className: "p-2",
                                                                                    colSpan: 2
                                                                                  }),
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "Current Month",
                                                                                    className: "p-2",
                                                                                    colSpan: 2
                                                                                  }),
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "Last Month",
                                                                                    className: "p-2",
                                                                                    colSpan: 2
                                                                                  })
                                                                            ],
                                                                            className: "bg-gray-600 text-white border-b-2"
                                                                          }),
                                                                      JsxRuntime.jsxs("tr", {
                                                                            children: [
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "Type",
                                                                                    className: "p-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "NPS Score",
                                                                                    className: "p-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "Total Responses",
                                                                                    className: "p-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "NPS Score",
                                                                                    className: "p-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "Total Responses",
                                                                                    className: "p-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "NPS Score",
                                                                                    className: "p-2"
                                                                                  }),
                                                                              JsxRuntime.jsx("th", {
                                                                                    children: "Total Responses",
                                                                                    className: "p-2"
                                                                                  })
                                                                            ],
                                                                            className: "border border-black"
                                                                          })
                                                                    ],
                                                                    className: "font-medium bg-secondary\n                    text-gray-400"
                                                                  }),
                                                              JsxRuntime.jsxs("tbody", {
                                                                    children: [
                                                                      ratingComparisonReportRow(report, "Marketplace"),
                                                                      ratingComparisonReportRow(report, "Non Marketplace"),
                                                                      ratingComparisonReportRow(report, "Overall")
                                                                    ],
                                                                    className: "text-center"
                                                                  })
                                                            ],
                                                            className: "w-full"
                                                          })
                                                    ],
                                                    className: "mb-50-px"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Rolling 5 day NPS trend",
                                                            className: "text-xl font-bold"
                                                          }),
                                                      tmp$1
                                                    ],
                                                    className: "w-full mb-50-px border border-black border-2\n                p-10-px"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Daily NPS Trend(Week wise view):",
                                                            className: "text-xl font-bold mb-10-px"
                                                          }),
                                                      JsxRuntime.jsxs("table", {
                                                            children: [
                                                              JsxRuntime.jsx("thead", {
                                                                    children: JsxRuntime.jsxs("tr", {
                                                                          children: [
                                                                            JsxRuntime.jsx("th", {
                                                                                  children: "Week of NPS Received Daate",
                                                                                  className: "p-2"
                                                                                }),
                                                                            JsxRuntime.jsx("th", {
                                                                                  children: "Monday",
                                                                                  className: "p-2"
                                                                                }),
                                                                            JsxRuntime.jsx("th", {
                                                                                  children: "Tuesday",
                                                                                  className: "p-2"
                                                                                }),
                                                                            JsxRuntime.jsx("th", {
                                                                                  children: "Wednesday",
                                                                                  className: "p-2"
                                                                                }),
                                                                            JsxRuntime.jsx("th", {
                                                                                  children: "Thursday",
                                                                                  className: "p-2"
                                                                                }),
                                                                            JsxRuntime.jsx("th", {
                                                                                  children: "Friday",
                                                                                  className: "p-2"
                                                                                }),
                                                                            JsxRuntime.jsx("th", {
                                                                                  children: "Saturday",
                                                                                  className: "p-2"
                                                                                }),
                                                                            JsxRuntime.jsx("th", {
                                                                                  children: "Sunday",
                                                                                  className: "p-2"
                                                                                })
                                                                          ]
                                                                        }),
                                                                    className: "font-medium border border-gray-400 bg-ghostwhite text-aurometalsaurus rounded-t-lg"
                                                                  }),
                                                              JsxRuntime.jsxs("tbody", {
                                                                    children: [
                                                                      weeklyReportRow(report.weeklyNpsTrend.overall),
                                                                      $$Array.of_list(Belt_List.map(report.weeklyNpsTrend.weeks, weeklyReportRow))
                                                                    ],
                                                                    className: "text-center border border-gray-400"
                                                                  })
                                                            ],
                                                            className: "w-full"
                                                          })
                                                    ],
                                                    className: "mb-50-px"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("p", {
                                                            children: "Promoter-Demoter Trend:",
                                                            className: "text-xl font-bold"
                                                          }),
                                                      tmp$2
                                                    ],
                                                    className: "w-full mb-50-px border border-black border-2\n                p-10-px"
                                                  })
                                            ]
                                          })
                                    })
                              ],
                              className: "flex flex-col justify-center"
                            }),
                        className: "bg-white px-10-px",
                        id: "daily-report"
                      }),
                  className: "m-16"
                })
          ],
          className: "flex flex-col"
        });
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(tmp)
            });
}

var make = DailyReport;

exports.ratingReportRowDecoder = ratingReportRowDecoder;
exports.ratingReportDecoder = ratingReportDecoder;
exports.weeklyReportRowDecoder = weeklyReportRowDecoder;
exports.weeklyReportDecoder = weeklyReportDecoder;
exports.weeklyReportRow = weeklyReportRow;
exports.ratingReportHeader = ratingReportHeader;
exports.ratingReportRow = ratingReportRow;
exports.reportDecoder = reportDecoder;
exports.downloadAsPdf = downloadAsPdf;
exports.ratingComparisonReportRow = ratingComparisonReportRow;
exports.make = make;
/* react Not a pure module */
